import React from 'react';
import { useTheme, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const ModalStyle = withStyles({
  paper: {
    borderRadius: 0,
    width: '100%',
    overflowY: 'scroll',
    '@media (min-height:700px)': {
      '&::-webkit-scrollbar': {
        display: 'none',
        height: 0,
      },
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none'
    }
  }
})(Dialog);

export default function Modal({
  children,
  disableBackdropClick,
  headerClassName,
  headerText,
  id,
  maxWidth,
  modalClassName,
  open,
  onClose,
  onClickHandler,
  showCloseIcon
}) {
  const theme = useTheme();
  const fullScreenDialog = useMediaQuery(theme.breakpoints.only('xs'));
  return (
    <ModalStyle
      className={modalClassName}
      fullWidth
      id={id}
      fullScreen={fullScreenDialog}
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      disableBackdropClick={disableBackdropClick}
      aria-labelledby="scroll-dialog-title"
      data-metrics-location="PU"
    >
      {showCloseIcon && (
        <div style={{ height: '62px', position: 'relative', paddingTop: '16px' }}>
          <div style={{ position: 'absolute', right: 0, paddingRight: '16px' }}>
            <IconButton size="small" aria-label="close" color="inherit" onClick={onClickHandler}>
              <CloseIcon alt='close-icon' fontSize="small" />
            </IconButton>
          </div>
        </div>
      )}
      <div className={headerClassName}>{headerText}</div>
      {children}
    </ModalStyle>
  )
}
